import Cookies from 'js-cookie';

export const fireOnce = (identifier: string, callback: () => void) => {
  const cookieName = `wlanalytics.${identifier}`;
  const done = Cookies.get(cookieName);
  if (done) {
    console.log(`[WL Analytics] Event already fired for ${identifier}`);
    return;
  }
  Cookies.set(cookieName, 'true', { expires: 1 }); // expires in 1 day
  callback();
};
